<template>
    <div class="pkjh">
        <div class="vhdd">
			<secret @orderId="getOrderId"></secret>
			<div class="oiuhgh">
				<ul>
					<li class="lione">
						<div class="tgss">
							<span class="stat-ico"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2.8" y="6" width="18.4" height="12" rx="2.6"/><path d="M2.8 10.4h18.4"/><path d="M16.5 14.6h2.2"/></svg></span>
							<h6>账户余额</h6>
						</div>
						<div class="efgbn">{{userInfo.accountBalance || 0}} <span>元</span></div>
						<div class="cgyu"><router-link :to="getUrl('/charge')">充值</router-link></div>
					</li>
					<li class="litwo">
						<div class="tgss">
							<span class="stat-ico"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="6" rx="2"/><rect x="3" y="14" width="18" height="6" rx="2"/><path d="M7 7h.01M7 17h.01"/></svg></span>
							<h6>我的接口</h6>
						</div>
						<div class="efgbn">{{userInfo.intfNum || 0}} <span>条</span></div>
						<div class="cgyu"><router-link :to="getUrl('/center/case3')">查看</router-link></div>
					</li>
					<li class="lithree">
						<div class="tgss">
							<span class="stat-ico"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2.8h12v18.4l-3-1.8-3 1.8-3-1.8-3 1.8z"/><path d="M9 8h6M9 12h6"/></svg></span>
							<h6>我的订单</h6>
						</div>
						<div class="efgbn">{{userInfo.orderNum || 0}} <span>条</span></div>
						<div class="cgyu"><router-link :to="getUrl('/center/case5')">查看</router-link></div>
					</li>
				</ul>
			</div>
			<div class="bhuj">
				<h6>账户信息</h6>
				<ul>
					<li>
						<p>账号：</p>
						<span>{{userInfo.accountNum || '--'}}</span>
					</li>
					<li>
						<p>用户名：</p>
						<span class="rghhs">{{getNmae}}</span>
							<span class="row-edit" @click="type='editName';editPop=true"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg></span>
					</li>
					<li>
						<p>用户类型：</p>
						<span>{{userInfo.type===1?'个人':userInfo.type===2?'企业':'--'}}</span>
					</li>
					<li>
						<p>手机号：</p>
						<span>{{$phone(userInfo.phone) || '--'}}</span>
							<span class="row-edit" @click="type='editPhone';editPop=true"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg></span>
					</li>
					<li>
						<p>邮箱：</p>
						<span>{{userInfo.email || '--'}}</span>
							<span class="row-edit" @click="type='editMail';editPop=true"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg></span>
					</li>
					<li>
						<p>企业名称：</p>
						<span>{{userInfo.orgName || '--'}}</span>
					</li>
					<li v-if="!userInfo.orgCertState">
						<p>企业认证：</p>
						<span>--</span>
					</li>
					<li v-if="userInfo.orgCertState===1">
						<p>企业认证：</p>
						<span class="color2">未认证</span>
						<a @click="goCert">立即认证</a>
					</li>
					<li v-if="userInfo.orgCertState===2">
						<p>企业认证：</p>
						<span class="color2">审核中</span>
					</li>
					<li v-if="userInfo.orgCertState===3">
						<p>企业认证：</p>
						<span class="color3">审核未通过</span>
						<el-tooltip class="item" effect="dark" :content="userInfo.orgCertStateDesc" placement="top-start">
							<div class="thssw">?</div>
						</el-tooltip>
						<a @click="goCert">重新认证</a>
					</li>
					<li v-if="userInfo.orgCertState===4">
						<p>企业认证：</p>
						<span class="color4">认证成功</span>
						<a @click="goCert">更新认证</a>
					</li>
					<li v-if="userInfo.orgCertState===5">
						<p>企业认证：</p>
						<span class="color3">认证过期</span>
						<a @click="goCert">重新认证</a>
					</li>
					<!-- <li>
						<p>企业认证：</p>
						<span v-bind:class="{'color2':userInfo.orgCertState===2,'color3':userInfo.orgCertState===3,'color4':userInfo.orgCertState===4}">{{userInfo.orgCertState===2?'审核中':userInfo.orgCertState===3?'审核未通过':userInfo.orgCertState===4?'认证成功':'未认证'}}</span>
						<a @click="goCert">{{userInfo.orgCertState===2?'':userInfo.orgCertState===3?'重新认证':userInfo.orgCertState===4?'更新认证':'立即认证'}}</a>
					</li> -->
				</ul>
			</div>
		</div>
        <router-view></router-view>
		
		<el-dialog :visible.sync="editPop" :close-on-click-modal="false" :before-close="handleClose" :title="type==='editName'?'修改用户名':type==='editPhone'?'修改手机号':type==='editMail'?'修改邮箱':''" width="470px">
			<div class="vft6" v-loading="loading">
				<!-- <h6>修改用户名</h6> -->
				<el-form :model="editForm" ref="editForm" :rules="rules" :label-width="type==='editMail'?'80px':type==='editPhone'?'130px':'60px'">
				  <el-form-item prop="username" v-if="type==='editName'" label="用户名">
					<el-input placeholder="请输入用户名（50个汉字、字母、数字组合）" v-model="editForm.username" autocomplete="off" clearable></el-input>
				  </el-form-item>
				  <p class="ojsjs" v-if="type==='editPhone'">为保护账号安全，请使用{{$phone(userInfo.phone)}}验证身份</p>
				  <el-form-item class="rtghs" prop="oldPhoneCode" v-if="type==='editPhone'" label="当前手机号验证码">
					<el-input placeholder="请输入验证码" maxlength="6" v-model="editForm.oldPhoneCode" autocomplete="off"></el-input>
					<div v-bind:class="{'gray': time!=60,'iughw':time===60}" @click="getCode1">{{time===60?'获取验证码':time + 's'}}</div>
				  </el-form-item>
				  <el-form-item v-if="type==='editPhone'" prop="newPhone" label="新手机号">
					<el-input placeholder="请输入手机号" maxlength="11" v-model="editForm.newPhone" autocomplete="off"></el-input>
				  </el-form-item>
				  <el-form-item class="rtghs" prop="newPhoneCode"  v-if="type==='editPhone'" label="新手机号验证">
					<el-input placeholder="请输入验证码" maxlength="6" v-model="editForm.newPhoneCode" autocomplete="off"></el-input>
					<div v-bind:class="{'gray': time1!=60,'iughw':time1===60}" @click="getCode2">{{time1===60?'获取验证码':time1 + 's'}}</div>
				  </el-form-item>
				  <el-form-item v-if="type==='editMail'" label="当前邮箱">
					  <p style="text-align: left;">{{userInfo.email}}</p>
				  </el-form-item>
				  <el-form-item v-if="type==='editMail'" prop="email" label="新邮箱">
					<el-input placeholder="请输入新邮箱" v-model="editForm.email" autocomplete="off" clearable></el-input>
				  </el-form-item>
				</el-form>
				<div slot="footer" @click="login('editForm')" class="dialog-footer">
				  确认
				</div>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import secret from '../../../components/secret.vue'
import { authApi, userApi } from '@/api'
let timer = null
let timer1 = null
export default {
    namme:'case1',
	components:{
	  secret
	},
    data(){
		var validatePhone = (rule, value, callback) => {
		  if (this.type === 'editPhone') {
				if (value === '') {
					callback(new Error('请输入手机号'));
				}
				if(!/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(value)) {
					callback(new Error('请输入正确手机号'));
				}
			}
			callback();
		};
		
		var validateCode = (rule, value, callback) => {
		  if (this.type === 'editPhone' && !value) {
			callback(new Error('验证码不能为空'));
		  }
		  callback()
		};
		
		var validateName = (rule, value, callback) => {
		  if (this.type === 'editName' && !value) {
			  callback(new Error('请输入用户名'))
		  }
		  callback();
		};
		
		var validateEmail = (rule, value, callback) => {
			if (this.type === 'editMail' && !value) {
			  callback(new Error('请输入邮箱地址'))
			}
			callback();
		};
		
        return{
			oldPhone: '13161257793',
			userInfo:{},
			editForm: {
			  username: '',
			  newPhone: '',
			  oldPhoneCode: '',
			  newPhoneCode: '',
			  email: ''
			},
			editPop: false,
			loading: false,
			type: 'editPhone',
			time: 60,
			disabledClick: false,
			time1: 60,
			disabledClick1: false,
			rules: {
			  username: [
				{ validator: validateName, trigger: 'blur' }
			  ],
			  newPhone: [
				{ validator: validatePhone, trigger: 'blur' }
			  ],
			  oldPhoneCode: [
			  	{ validator: validateCode, trigger: 'blur' }
			  ],
			  newPhoneCode: [
			  	{ validator: validateCode, trigger: 'blur' }
			  ],
			  email: [
			  	{ validator: validateEmail, trigger: 'blur' }
			  ]
			},
			orderId: ''
        }
    },
	computed: {
		getNmae() {
			let na = this.userInfo.username || '--'
			console.log(na)
			return na.length>15?na.slice(0,15)+'...':na
		}
	},
	watch: {
		editPop: function(newVal,oldVal) {
			if (newVal) {
				this.$store.commit('setOtherMeng',1)
			} else {
				this.$store.commit('setOtherMeng',0)
			}
		}
	},
    methods:{
		getUrl(str) {
			return `${str}?orderId=${this.orderId}`
		},
		getOrderId(val) {
			// if(!val) return
			this.orderId = val
			this.getCase()
		},
		handleClose(done) {
			// this.$store.commit('setOtherMeng',0)
			done();
		},
		resetName(name) {
			let user = this.$cookies.getJSON('user')
			user.userName = name
			this.$cookies.set('user', user, { expires: 0.7 })
		},
        getCase:function(){
            let params = {
				  userId: this.$cookies.getJSON('user').userId,
				  orderId: this.orderId
			  }
            userApi.getAccountInfo(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					this.userInfo = res.data
					this.$store.commit('setUserName',res.data.username)
					this.resetName(res.data.username)
				  } else {
					this.$message.error(res.message);
				  }
			  })
			  .catch(err=>{
				  alert(err);
			  })
        },
		login(form) {
		  this.$refs[form].validate((valid) => {
			if (valid) {
				let request = userApi.updatePhone
				let params = {}
				this.loading = true
				if(this.type === 'editPhone') {
					params = {
						phone: this.editForm.newPhone,
						captcha: this.editForm.oldPhoneCode,
						newCaptcha: this.editForm.newPhoneCode
					}
					request = userApi.updatePhone
				} else if(this.type === 'editName') {
					params = {
						username: this.editForm.username
					}
					request = userApi.updateUsername
				} else if(this.type === 'editMail') {
					params = {
						email: this.editForm.email
					}
					request = userApi.updateEmail
				}
				params['userId'] = this.$cookies.getJSON('user').userId
				request(params)
				  .then((res) =>{
					  console.log(res)
					  if (res.state===200) {
						
					  } else {
						this.$message.error(res.message);
					  }
					  this.getCase()
					  this.editPop = false
					  this.loading = false
				  })
				  .catch(err=>{
					  this.loading = false
					  this.$message.error(err);
				  })
			} else {
			  console.log('error submit!!');
			  return false;
			}
		  });
		},
		getCode1() {
		  let _this = this
		  if(_this.disabledClick) return
		 //  if(!/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(this.editForm.phone)) {
			// this.$message.error('请先输入正确手机号');
			// return
		 //  }
		 let params = {
			phone: this.userInfo.phone,
			captchaType: 4
		 }
		 authApi.sendCaptcha(params)
		 .then((res) =>{
		     console.log(res)
			  if (res.state===200) {
				_this.disabledClick = true
				_this.time--
				timer =  setInterval(function(){
				  if (_this.time===0) {
					  clearInterval(timer)
					  _this.disabledClick = false
					  _this.time = 60
					  return
				  }
				  _this.disabledClick = true
				  _this.time--
				},1000)  
			  } else {
				this.$message.error(res.message);
			  }
		 })
		 .catch(err=>{
			  this.$message.error(err);
		 })
		},
		getCode2() {
		  let _this = this
		  if(_this.disabledClick1) return
		  if(!/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(this.editForm.newPhone)) {
			this.$message.error('请先输入正确手机号');
			return
		  }
		  if (this.editForm.newPhone == this.userInfo.phone) {
			this.$message.error('修改号码不能和旧号码一样');
			return
		  }
		  let params = {
			phone: this.editForm.newPhone,
			captchaType: 4
		  }
		  authApi.sendCaptcha(params)
		  .then((res) =>{
		      console.log(res)
			  if (res.state===200) {
				_this.disabledClick1 = true
				_this.time1--
				timer1 =  setInterval(function(){
				  if (_this.time===0) {
					  clearInterval(timer1)
					  _this.disabledClick1 = false
					  _this.time1 = 60
					  return
				  }
				  _this.disabledClick1 = true
				  _this.time1--
				},1000)
			  } else {
				this.$message.error(res.message);
			  }
		  })
		  .catch(err=>{
			  this.$message.error(err);
		  })
		  
		},
		goCert:function() {
			this.$router.push('/center/case2')
		}
    },
    mounted(){
		this.$store.commit('setCenterIndex',0)
    }
}
</script>



// WEBPACK FOOTER //
// src/views/center/caseChild/case1.vue